module.exports = __webpack_public_path__ + "img/liveNum8.63f34563.png";